export default __webpack_public_path__ + "static/media/Certificado.c068c0e2.pdf";